import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';

import PrismTabsContainerTabHeader from './tab-header.gts';

interface PrismTabsContainerHeaderSignature {
  Args: {
    activeTabId: string;
    onSelectTab: (tabId: string) => unknown;
    visibleTabIds: string[];
  };
  Blocks: {
    after: [];
    default: [
      {
        tab: WithBoundArgs<
          typeof PrismTabsContainerTabHeader,
          'onSelectTab' | 'visibleTabIds' | 'activeTabId'
        >;
      },
    ];
  };
  Element: HTMLElement;
}

const PrismTabsContainerHeader = <template>
  <header class="prism-tabs-container__header" ...attributes>
    <nav class="prism-tabs-container__header__tabs">
      <ul class="prism-tabs-container__header__tabs__list">
        {{yield
          (hash
            tab=(component
              PrismTabsContainerTabHeader
              activeTabId=@activeTabId
              onSelectTab=@onSelectTab
              visibleTabIds=@visibleTabIds
            )
          )
        }}
      </ul>
    </nav>
    <div class="prism-tabs-container__header__actions">
      {{yield to="after"}}
    </div>
  </header>
</template> satisfies TOC<PrismTabsContainerHeaderSignature>;

export default PrismTabsContainerHeader;
